/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Notification_StatusInputs */

const tr_landing_genius_agent_notification_status = /** @type {(inputs: Landing_Genius_Agent_Notification_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni sipariş · Hepsiburada · Telegram'a bildirildi.`)
};

const en_landing_genius_agent_notification_status = /** @type {(inputs: Landing_Genius_Agent_Notification_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New order · Hepsiburada · sent to Telegram.`)
};

const de_landing_genius_agent_notification_status = /** @type {(inputs: Landing_Genius_Agent_Notification_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Bestellung · Hepsiburada · an Telegram gemeldet.`)
};

const ru_landing_genius_agent_notification_status = /** @type {(inputs: Landing_Genius_Agent_Notification_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый заказ · Hepsiburada · отправлено в Telegram.`)
};

/**
* | output |
* | --- |
* | "New order · Hepsiburada · sent to Telegram." |
*
* @param {Landing_Genius_Agent_Notification_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_notification_status = /** @type {((inputs?: Landing_Genius_Agent_Notification_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Notification_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_notification_status(inputs)
	if (locale === "de") return de_landing_genius_agent_notification_status(inputs)
	if (locale === "ru") return ru_landing_genius_agent_notification_status(inputs)
	return tr_landing_genius_agent_notification_status(inputs)
});